window.KlaviyoBackInStockInit = function(bis_form) {
  if (!bis_form) return;
  if (bis_form._klaviyoInit) return;
  bis_form._klaviyoInit = true;
  const messageContainer = bis_form.closest('.pdp-sold-out-form__form')?.querySelector('.form-message');
  const klaviyoAPIKey = bis_form.getAttribute('data-klaviyo-api-key');
  if (!messageContainer) return;
  bis_form.addEventListener('submit', function(e) {
    e.preventDefault();
    const productID = bis_form.getAttribute('data-product-id');

      const emailInput = bis_form.querySelector('input[type="email"]');
      const notifyButton = bis_form.querySelector('button');
      notifyButton.textContent = "Sending...";
      notifyButton.disabled = true;
      const email = emailInput.value;

      const myHeaders = new Headers({
        "revision": "2024-07-15",
        "Content-Type": "application/json",
        "Accept": "application/json"
      });

      const raw = JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email
                },
                properties: {
                  source: "Back in Stock Form"
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${productID}`
              }
            }
          }
        }
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoAPIKey}`, requestOptions)
        .then(response => {
          console.log(response);
          if (response.status === 202) {
            messageContainer.className = 'success-msg';
            messageContainer.textContent = "Success! You will be notified when the product is back in stock.";
            emailInput.value = "";
            notifyButton.textContent = "Notify Me";
            notifyButton.disabled = false;
          } else {
            messageContainer.className = 'error-msg';
            messageContainer.textContent = "Error: Something went wrong. Please try again.";
          }
        })
        .catch(error => {
          console.error('API error:', error);
          messageContainer.className = 'error-msg';
          messageContainer.textContent = "Error: Unable to process your request. Please try again later.";
        });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form.notify-form').forEach(form => {
    window.KlaviyoBackInStockInit(form);
  });
});